module.exports = __webpack_public_path__ + "static/img/duofangguangbo.b9e5562.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/duofangguangbo.png
// module id = zX7b
// module chunks = 24